import { takeLatest, call, put } from 'redux-saga/effects';
import { GET_ABOUT_US_ERROR, GET_ABOUT_US_START, GET_ABOUT_US_SUCCESS } from '../../types';

import apiCall from '../../../api/apiGet';

export function* get({ payload }) {
  try {
    const url = payload.lang ? `/about-us/${payload.lang}` : '/about-us/';
    const method = 'GET';
    const headers = {Authorization: `Bearer ${payload.token}`};
    const results = yield call(apiCall, url, method, headers);
    console.log(results)
    yield put({ type: GET_ABOUT_US_SUCCESS, results: results.data });

  } catch (error) {
    console.log(error)
    yield put({ type: GET_ABOUT_US_ERROR, error });
  }
}

export default function* get_about_us() {
  yield takeLatest(GET_ABOUT_US_START, get);
}
